import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/buy',
  name: 'EstateBuyModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EstateBuyMainRoute',
      component: () => import('./views/BuyView.vue'),
      meta: {
        title: 'buy.buyContract',
      },
    },
    {
      path: 'create',
      name: 'EstateBuyCreateRoute',
      component: () => import('./views/BuyUpsertView.vue'),
      meta: {
        title: 'buy.createBuyContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:buyId',
      name: 'EstateBuyEditRoute',
      component: () => import('./views/BuyUpsertView.vue'),
      meta: {
        title: 'buy.editBuyContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:buyId',
      name: 'ViewEstateBuyRoute',
      component: () => import('./views/SingleBuyView.vue'),
      meta: {
        title: 'buy.ViewBuy',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
